import { typeCustomerAddress } from "./customerAddress"
import { mutationCreateCustomerAddress } from "./mutations/mutationCreateCustomerAddress"
import { mutationRemoveDefaultBillingAddress } from "./mutations/mutationRemoveDefaultBillingAddress"
import { mutationRemoveDefaultShippingAddress } from "./mutations/mutationRemoveDefaultShippingAddress"
import { mutationSetCustomerAddressStatus } from "./mutations/mutationSetCustomerAddressStatus"
import { mutationSetDefaultBillingAddress } from "./mutations/mutationSetDefaultBillingAddress"
import { mutationSetDefaultShippingAddress } from "./mutations/mutationSetDefaultShippingAddress"
import { mutationUpdateCustomerAddress } from "./mutations/mutationUpdateCustomerAddress"
import { queryCustomerAddress } from "./queries/queryCustomerAddress"
import { queryCustomerAllAddresses } from "./queries/queryCustomerAllAddresses"
import { queryCustomerBillingAddresses } from "./queries/queryCustomerBillingAddresses"
import { queryCustomerContactAddresses } from "./queries/queryCustomerContactAdresses"
import { queryCustomerShippingAddresses } from "./queries/queryCustomerShippingAddresses"

const customerAddressSchema = {
  types: [typeCustomerAddress],
  resolvers: {
    Query: {
      ...queryCustomerAddress,
      ...queryCustomerAllAddresses,
      ...queryCustomerBillingAddresses,
      ...queryCustomerContactAddresses,
      ...queryCustomerShippingAddresses,
    },
    Mutation: {
      ...mutationCreateCustomerAddress,
      ...mutationRemoveDefaultBillingAddress,
      ...mutationRemoveDefaultShippingAddress,
      ...mutationSetCustomerAddressStatus,
      ...mutationSetDefaultBillingAddress,
      ...mutationSetDefaultShippingAddress,
      ...mutationUpdateCustomerAddress,
    },
  },
}

export default customerAddressSchema
